import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Upload } from "antd";
import logo from "../../../assets/excelTeml/tempThreshold.xls";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class GoodExcelInTempClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      btnLoading: false,
      msg: "",
    };
  }

  formRef = React.createRef();

  render() {
    const uploadProps = {
      name: "file",
      multiple: false,
      accept: ".xls",
      action: `${window.sessionStorage.getItem("prefixFile")}/mtsV2/stubcfg/batchSave`,
      headers: {
        authorization: window.sessionStorage.getItem("token"),
      },
      showUploadList: false,
      onChange: (info) => {
        this.setState({
          btnLoading: true,
          msg: "",
        });
        console.log("infoinfoinfo", info);
        if (info.file.response !== undefined && info.file.response === 1) {
          this.setState({
            msg: "",
            btnLoading: false,
          });
          this.state.display = "";
          message.success("导入成功");
          if (this.props.onCancel) {
            this.props.onCancel();
          }
          if (this.props.refreshGrid) {
            this.props.refreshGrid();
          }
        } else if (info.file.response !== undefined && info.file.response.status !== "200") {
          this.setState({
            btnLoading: false,
            msg: info.file.response.message ? info.file.response.message : info.file.response.text,
          });
          message.error(
            info.file.response.message ? info.file.response.message : info.file.response.text,
          );
        }
      },
    };
    return (
      <div>
        <a style={{ marginBottom: "20px", display: "inline-block" }} target="_blank" href={logo}>
          模板下载
        </a>
        <Form ref={this.formRef}>
          <Upload {...uploadProps}>
            <Button type="primary" loading={this.state.btnLoading}>
              上传并校验
            </Button>
          </Upload>
          <div style={{ margin: "5px 0 0 0", color: "red" }}>
            <span>{this.state.msg}</span>
          </div>
        </Form>
      </div>
    );
  }
}

const GoodExcelInTemp = Form.create()(GoodExcelInTempClass);

export default injectIntl(GoodExcelInTemp);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/goodExcelInTemp.js